import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from './context/CartContext';
import { VehicleProvider } from './context/VehicleContext';
import Layout from './components/Layout/Layout';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import SessionTracker from './components/Analytics/SessionTracker';
import HomePage from './pages/HomePage/HomePage';
import ArlistaPage from './pages/ArlistaPage/ArlistaPage';
import AkkuvalasztoPage from './pages/AkkuvalasztoPage/AkkuvalasztoPage';
import MegrendelesPage from './pages/MegrendelesPage/MegrendelesPage';
import MegrendelesOkPage from './pages/MegrendelesPage/MegrendelesOkPage';
import BlogListPage from './pages/BlogListPage/BlogListPage';
import ArticlePage from './pages/ArticlePage/ArticlePage';
import TermsPage from './pages/TermsPage/TermsPage';
import PrivacyPage from './pages/PrivacyPage/PrivacyPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';

export default function App() {
	return (
		<HelmetProvider>
			<VehicleProvider>
				<CartProvider>
					<BrowserRouter>
						<ScrollToTop />
						<SessionTracker />
						<Routes>
							<Route element={<Layout />}>
								<Route path="/" element={<HomePage />} />
								<Route path="/arlista" element={<ArlistaPage />} />
								<Route path="/akkuvalaszto" element={<AkkuvalasztoPage />} />
								<Route path="/megrendeles" element={<MegrendelesPage />} />
								<Route path="/megrendeles/sikeres" element={<MegrendelesOkPage />} />
								<Route path="/blog" element={<BlogListPage />} />
								<Route path="/blog/:slug" element={<ArticlePage />} />
								<Route path="/vasarlasi-feltetelek" element={<TermsPage />} />
								<Route path="/adatvedelem" element={<PrivacyPage />} />
								{/* Catch-all: unknown URLs get a noindex'd not-found page instead of a
								    soft-404 (nginx serves the shell with 200 for every client route). */}
								<Route path="*" element={<NotFoundPage />} />
							</Route>
						</Routes>
					</BrowserRouter>
				</CartProvider>
			</VehicleProvider>
		</HelmetProvider>
	);
}
